/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

import api from '../../../services/api';

export default function CategoryFormModal({
  open,
  onClose,
  expositionId,
  categoryToEdit,
  onSaved,
}) {
  const isEditMode = !!categoryToEdit;

  const [name, setName] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) {
      setName('');
      return;
    }
    if (categoryToEdit) setName(categoryToEdit.name || '');
  }, [open, categoryToEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      alert('Nome é obrigatório.');
      return;
    }

    setSubmitting(true);
    try {
      const data = isEditMode ? { name: name.trim() } : { name: name.trim(), expositionId };
      const saved = isEditMode
        ? (await api.patch(`/categories/${categoryToEdit.id}`, data)).data
        : (await api.post('/categories', data)).data;
      alert(isEditMode ? 'Categoria atualizada.' : 'Categoria criada.');
      if (onSaved) onSaved(saved);
      onClose();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || `Erro ao ${isEditMode ? 'atualizar' : 'cadastrar'} categoria.`);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (!categoryToEdit) return;
    if ((categoryToEdit.points || []).length > 0) {
      alert('Não é possível excluir esta categoria — ela possui pontos associados.');
      return;
    }
    if (!window.confirm('Tem certeza que deseja excluir esta categoria?')) return;

    setSubmitting(true);
    try {
      await api.delete(`/categories/${categoryToEdit.id}`);
      alert('Categoria excluída.');
      if (onSaved) onSaved(null);
      onClose();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || 'Erro ao excluir categoria.');
    } finally {
      setSubmitting(false);
    }
  };

  const title = isEditMode ? 'Editar categoria' : 'Nova categoria';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
            Categorias agrupam pontos dentro de uma exposição (ex: sala, andar, corredor).
          </Typography>

          <FormControl fullWidth sx={{ my: 1 }}>
            <TextField
              label="Nome"
              type="text"
              value={name}
              placeholder="Ex.: Recepção"
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
            />
          </FormControl>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
          <div>
            {isEditMode ? (
              <Button
                color="error"
                onClick={handleDelete}
                disabled={submitting}
              >
                Excluir
              </Button>
            ) : null}
          </div>
          <div>
            <Button onClick={onClose} disabled={submitting} sx={{ mr: 1 }}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="success"
              disabled={submitting}
            >
              {(() => {
                if (submitting) return 'Salvando...';
                return isEditMode ? 'Salvar' : 'Cadastrar';
              })()}
            </Button>
          </div>
        </DialogActions>
      </form>
    </Dialog>
  );
}

CategoryFormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  expositionId: PropTypes.string,
  onSaved: PropTypes.func,
  categoryToEdit: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    points: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),
  }),
};
